import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { routes } from './routes-names';
// import { useSelector } from 'react-redux';
// import { RootState } from '../../redux';
import PageLoader from '../../components/loader';
import { useAppSelector } from '../../redux/hooks';

// type Props = RouteProps;
interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute :React.FC<ProtectedRouteProps>= ({children}) => {
    const { loading, user } = useAppSelector((state) => state.user);
    const navigate=useNavigate();
    useEffect(() => {
        if (loading || user) return;
        navigate(routes.main);
    }, [loading, user]);

    // return user ? <Route {...props} /> : <PageLoader />;
    return user ? <>{children}</>: <PageLoader />;
};

export default ProtectedRoute;
